import { render, staticRenderFns } from "./KtbFastPaySuccess.vue?vue&type=template&id=64422608&scoped=true"
import script from "./KtbFastPaySuccess.vue?vue&type=script&lang=js"
export * from "./KtbFastPaySuccess.vue?vue&type=script&lang=js"
import style0 from "./KtbFastPaySuccess.vue?vue&type=style&index=0&id=64422608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64422608",
  null
  
)

export default component.exports